import { createAsyncThunk } from "@reduxjs/toolkit";
import { TrackingSessionService } from "../../../services/firebase/trackingSessionService";
import { TrackingSession, LocationPoint, TrackingSessionFilters } from "../../../types/model/trackingSessionTypes";

export const fetchTrackingSessions = createAsyncThunk<
  TrackingSession[],
  TrackingSessionFilters,
  { rejectValue: string }
>(
  "trackingSessions/fetchList",
  async (filters, { rejectWithValue }) => {
    try {
      console.log("[fetchTrackingSessions] filters received:", filters);
      if (filters.userAccountId) {
        return await TrackingSessionService.listSessionsByUserAccountId(filters.userAccountId, filters);
      }
      return await TrackingSessionService.listSessions(filters);
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch tracking sessions");
    }
  }
);

export const fetchSessionById = createAsyncThunk<
  TrackingSession,
  string,
  { rejectValue: string }
>(
  "trackingSessions/fetchById",
  async (sessionId, { rejectWithValue }) => {
    try {
      const session = await TrackingSessionService.getSessionById(sessionId);
      if (!session) return rejectWithValue("Session not found");
      return session;
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch session");
    }
  }
);

export const fetchLocationPoints = createAsyncThunk<
  LocationPoint[],
  string,
  { rejectValue: string }
>(
  "trackingSessions/fetchLocationPoints",
  async (sessionId, { rejectWithValue }) => {
    try {
      return await TrackingSessionService.listLocationPoints(sessionId);
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch location points");
    }
  }
);
